export const CATEGORY_MAPPING = {
  beauty: "뷰티",
  fashion: "패션",
  market: "마켓(R/S)",
  lifeStyle: "라이프스타일",
  family: "패밀리",
  entertainment: "엔터테인먼트",
  pet: "반려동물",
  ITService: "IT서비스",
  trend: "트렌드",
  food: "식품",
  etc: "기타",
};

export const CATEGORY_STYLES = {
  beauty: {
    backgroundColor: "#F1F2F8",
    color: "#e03020",
  },
  fashion: {
    backgroundColor: "#F1F2F8",
    color: "#2c40f5",
  },
  market: {
    backgroundColor: "#F1F2F8",
    color: "#049589",
  },
  lifeStyle: {
    backgroundColor: "#F1F2F8",
    color: "#00ac4a",
  },
  family: {
    backgroundColor: "#F1F2F8",
    color: "#c0b30a",
  },
  entertainment: {
    backgroundColor: "#F1F2F8",
    color: "#ca8000",
  },
  pet: {
    backgroundColor: "#F1F2F8",
    color: "#6A3F28",
  },
  ITService: {
    backgroundColor: "#F1F2F8",
    color: "#4774df",
  },
  trend: {
    backgroundColor: "#F1F2F8",
    color: "#8f00b7",
  },
  food: {
    backgroundColor: "#F1F2F8",
    color: "#a40914",
  },
  etc: {
    backgroundColor: "#F1F2F8",
    color: "#3C4043",
  },
};
